module.exports = __webpack_public_path__ + "static/media/3_9.ac306ad2.png";